
<script>
  let { ...rest } = $props();
</script>

<svg
  fill="currentColor"
  viewBox="0 0 256 256"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M53.92,34.62A8,8,0,1,0,42.08,45.38L61.32,66.55C25.2,88.84,9.38,123.2,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208a127.11,127.11,0,0,0,52.07-10.83l22,24.21a8,8,0,1,0,11.84-10.76Zm74.07,125a32,32,0,0,1-43.27-44.15l8.64,9.51a16,16,0,0,0,21.61,20.49ZM24.7,128A169.47,169.47,0,0,1,48.07,97.29C70.33,75.19,97.22,64,128,64a112.26,112.26,0,0,1,19.77,1.74l-22,24.2A48,48,0,0,0,80,128c0,1.63.08,3.24.24,4.84L53.92,109A171.58,171.58,0,0,0,24.7,128Zm223,3.26c-.35-.79-8.82-19.58-27.65-38.41C194.57,67.26,162.88,54,128,54a125.07,125.07,0,0,0-23.42,2.19,8,8,0,0,0,3,15.72A109.2,109.2,0,0,1,128,70c30.78,0,57.67,11.19,79.93,33.29A169.47,169.47,0,0,1,231.3,134c-7.09,12.66-37.13,54-90.82,63a8,8,0,0,0,2.73,15.77A128.58,128.58,0,0,0,219.66,169.5c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.66,131.26Z"
  />
</svg>
